import { Icon } from '@/modules/Icon';
import { cn } from '@/shared/utils/cn';
import React from 'react';
import { faSearch } from '@fortawesome/pro-regular-svg-icons';

export interface ListSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  className?: string;
}

export const ListSearchInput: React.FC<ListSearchInputProps> = ({
  value,
  onChange,
  placeholder = 'Buscar...',
  className,
}) => {
  return (
    <div className={cn('ui-relative', className)}>
      <div className="ui-absolute ui-left-8 ui-top-1/2 ui--translate-y-1/2 ui-text-tertiary">
        <Icon name={faSearch} className="ui-text-16" />
      </div>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className="focus:ui-ring-brand ui-h-32 ui-w-full ui-rounded-control-sm ui-border ui-border-default ui-py-4 ui-pl-32 ui-pr-8 ui-text-body-sm-regular ui-text-primary ui-transition-all placeholder:ui-text-tertiary focus:ui-border-brand focus:ui-outline-none focus:ui-ring-1"
      />
    </div>
  );
};
